<template>
	<div
		class="input"
		:class="[editing ? 'input--editing' : '']">

		<label v-if="label" ref="label">{{ label }}</label>

		<div
			v-click-outside="cancel"
			class="input-content"
			:class="[border !== '' ? `border border-${border}` : '']"
			@keydown.escape.capture.stop.exact.prevent="cancel"
			@keydown.enter.stop.exact.prevent="enter"
			@keydown.shift.tab.exact="back"
			@keydown.tab.exact="next">
			
			<div v-if="!normal && (!editing || readonly)" :class="['input-content-wrap', {'input-number': type.includes('numeric')}]">
				
				<div
					v-if="typeof model === 'string' || typeof model === 'number' || typeof model === 'object'"
					
					@click.stop.prevent="clickToEdit()"
					:title="formatDate(model === '' || model === undefined || model === null ? placeholder : model, escapedType)"
					:class="[(!readonly) ? 'c-pointer' : '', 'ellipsis',{'placeholder': model === '' || model === undefined || model === null},{'type-number': typeof model === 'number' }]"
					style="width: 100%"
					>

					<template v-if="type == 'calendar'">
						{{ formatDate(model === '' || model === undefined || model === null ? placeholder : model, escapedType) }}
					</template>
					<template v-else>
						{{ (model === '' || model === undefined || model === null) ? placeholder : `${textPre} ${switchFormat(type, model)} ${textPos}` }}
					</template>
					
				</div>

				<div
					v-else
					@click.stop.prevent="clickToEdit()"
					:class="[!readonly ? 'c-pointer' : '']"
					style="width: 100%"
					>

					<div v-for="item in model" >

						<span class="mr-1 text-xs py-1 px-2 bg-primary rounded text-white">{{ item }}</span>

					</div>

				</div>
			</div>

			<div v-if="saving" class="spinner-center text-primary"></div>

			<template v-if="!readonly">

				<el-input
					v-show="editing || normal"
					ref="input"
					size="mini"
					:placeholder="placeholder"
					:style="style"
					:readonly="!normal && !editing"
					v-model="model"
					@focusout="$emit('change')">
				</el-input>

				<span
					v-if="!normal && !onlyConfirm"
					v-show="editing"
					@click="cancel"
					class="ml-2 c-pointer text-primary"
				><fa icon="times"></fa></span>

			</template>

			<div
				v-if="error !== ''"
				class="absolute pin-l pin-b text-xxs p-px">
				{{ error }}
			</div>

		</div>

		<div class="action-content">
			<div class="action-button" @click="go()">
				<fa icon="link"></fa>
			</div>
			<div class="action-button" @click="$emit('setActionId', input)">
				<fa icon="edit"></fa>
			</div>
		</div>

		<fa
		v-if="type === 11"
		@click="$emit('editarParrafo', {id})"
		class="cursor-pointer"
		icon="pen"></fa>
		
	</div>
</template>

<script>
	export default {
		name: 'InputId',
		props: {
			value: [String, Array, Number],
			id: [Number, String],
			input: Object,
			label: String,
			type: {
				type: [String, Number],
				default: 'text'
			},
			placeholder: String,
			readonly: {
				type: Boolean,
				default: false
			},
			siblings: {
				type: Array,
				default: () => []
			},
			saveFunction: {
				type: [Function, String],
				default: ''
			},
			separador: String,
			saveObject: {
				type: [Function, String],
				default: ''
			},
			normal: {
				type: Boolean,
				default: false
			},
			format: Function,
			onlyConfirm: {
				type: Boolean,
				default: false
			},
			border: {
				type: String,
				default: ''
			},
			rows: {
				type: Number,
				default: 1
			},
			required: {
				type: Boolean,
				default: false
			},
			textPre: String,
			textPos: String
		},
		computed: {
			style () {
				return {
					width: this.normal ? '100%' : (this.editing ? `calc(100% - ${ this.onlyConfirm ? '15px' : '20px' })` : '0px')
				}
			},
			escapedType () {
				const tipo = isNaN(this.type) ? this.type : this.inputsNumber[this.type]
				return ['select', 'textarea'].includes(tipo) ? tipo + 'Input' : (['go', 'id'].includes(tipo) ? 'text' : tipo)
			}
		},
		data () {
			return {
				editing: false,
				model: '',
				saving: false,
				error: '',
				inputsNumber: {
					1: 'date',
					2: 'text',
					3: 'number',
					4: 'autosuggest',
					5: 'autosuggest',
					6: 'text',
					8: 'autosuggest',
					9: 'text',
					10: 'date',
					11: 'text'
				}
			}
		},
		watch: {
			editing (newVal) {

				if (!newVal) {

					return

				}

				setTimeout(() => {
					this.$refs.input.select()
					this.$refs.input.focus()
				}, 200)

			},
			model (val) {
				
				this.error = ''
				
				if (!this.normal) return

				this.$emit('input', val)

			},
			value (val) {
				this.model = val
			}
		},
		created () {

			this.model = this.value

		},
		methods: {
			clickToEdit() {
				this.editing = !this.readonly
			},
			go() {
				if(!this.input.value) return
				this.openwindow(`/ficha/${this.input.entidad}/${this.input.value}`,'_blank')
			},
			save () {

				if (this.normal) return

				if (this.required && this.model === '') {

					this.error = 'Campo requerido'

					return

				}

				if (this.model !== this.value) this.guardarDato()

				this.editing = false

			},
			cancel () {
				
				this.error = ''

				if (this.normal) return

				if (this.$refs.input && this.$refs.input.hide) {

					this.$refs.input.hide()

				}

				if (!this.editing) return

				this.model = this.value

				this.editing = false

			},
			next (e) {
				

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) + 1

				if (index > this.siblings.length - 1) index = 0

				this.save()

				this.siblings[index].editing = true

			},
			back (e) {

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) - 1

				if (index < 0) index = this.siblings.length - 1

				this.save()

				this.siblings[index].editing = true

			},
			enter () {

				this.$emit('enter')

				if (this.editing) return this.save()

				this.editing = true

			},
			formatDate (date, type = 'calendar') {
				
				if (type !== 'calendar') {

					return this.format ? this.format(date) : date

				}

				if (date === this.placeholder) return date

				return moment(date, this.dateFormat).format(this.outputFormat)

			},

			async guardarDato () {
				
				if (this.saveFunction === '' || this.normal) return

				this.saving = true

				try {
					
					const resp = await this.saveFunction(this.objetoDato())
					console.log(resp)

					if(resp && resp.data) {
						this.$emit('saved', resp.data)
					} else {
						this.$emit('input', this.model)
					}

				} catch (e) {

					this.model = this.value

				}

				this.saving = false

			},

			objetoDato () {

				return this.saveObject ? this.saveObject(this.model, this) : { value: this.model }

			},

			async add () {

				this.model = await this.$refs.input.add()

				this.save()

			},

			componentChange(e) {
				console.log('componentChange',e)
				if (typeof e == 'object') {
					this.enter()
				} else {
					this.$emit('change')
				}
			},

			// REVISAR
			switchFormat (format, data) {
				switch(format){
					case 'formatPeso':
						return (typeof data !== 'undefined' && data!== '') ? this.formatPeso(data) : '';
						break;
					case 'calendar':
						return this.calendarFormat(data);
					case 'numeric0' :
						return (typeof data !== 'undefined' && data!== '') ?  this.FormatDecimals(data,0) : '';
						break;
					case 'numeric2' :
						return (typeof data !== 'undefined' && data!== '') ?  this.FormatDecimals(data,2) : '';
						break;
					case 'numeric4' :
						return (typeof data !== 'undefined' && data!== '') ?  this.FormatDecimals(data,4) : '';
						break;
					default:
						return data;
				}
			},

			formatPeso (data) {
				if(data !== null){
					peso = parseInt(data);
					if (peso > 1000){
						return ((peso/1000).toFixed(1)+ " ").replace('.',',') + "Tn";
					}else{
						return (peso + " ").replace('.',',') + "Kg";
					}
				}else{
					return '';
				}
			},

			calendarFormat (data) {
				console.log('calendar: ',data)
				if(data !== null){
					if (data.toString().indexOf("-") != -1) {
						if(data.indexOf(":") != -1) {
							let data1 = data.split(" ");
							let dataArray = data1[0].split("-");
							return dataArray[2] + '/' + dataArray[1] + "/" + dataArray[0];
						} else {
							let dataArray = data.split("-");
							return dataArray[2] + '/' + dataArray[1] + "/" + dataArray[0];
						}
					} else {
						return data;
					}
				}else{
					return '';
				}
			},

			FormatDecimals (number, decimals) {

				var d = ',';
				var t = '.';
				var c = 2;
				var n = number,
					c = isNaN(c = Math.abs(c)) ? 2 : c,
					d = d == undefined ? "." : d,
					t = t == undefined ? "," : t,
					s = n < 0 ? "-" : "",
					i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
					j = (j = i.length) > 3 ? j % 3 : 0;
				return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) + " " : "");
			}
		}
	}
</script>

<style lang="scss">

	.input {
		height: -webkit-fill-available;
		width: 100%!important;
		display: flex;
		flex-grow: 1;
		align-items:center;
		position: relative;
		border-radius: 3px;
    	border: 1px solid #e4e7ed;
		&--editing {
			border: 1px solid #e4e7ed;
			border-radius: 3px;
		}
		label {
			text-transform: capitalize;
			display: flex;
			flex-shrink: 0;
			color: #e4e7ed;
		}
		.input-content {
			display: flex;
			align-items: center;
			flex-grow: 1;
			width: 100%;
			.input-content-wrap {
				width: 100%;
				height: 100%;
				position: relative;
				display: flex;
				align-items: center;
				height: 100%;
				> div.ellipsis {
					padding: 5px;
    				font-size: 0.9rem;
					font-family: 'Open Sans', sans-serif!important;
					color: black;
    				font-weight: 600;
					&.placeholder {
						font-weight: 100!important;
						color: #b3b3b3!important;
					}
				}
				&.input-number > div {
					text-align: right;
				}
			}
		}

		.action-content {
			display: flex;
			flex-shrink: 0;
			.action-button {
				padding: 0px;
				margin-left: 2px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #ffffff;
				color: #4a596a;
				border: 1px solid #e4e7ed;
				padding: 0px;
				margin-left: 2px;
				border-radius: 3px;
				height: 28px;
				width: 28px;
				min-width: 28px;
				font-size: 13px;
				cursor: pointer;
			}
		}

		input, select {
			outline: 0;
			padding: 0 0 0 4px;
			border: 0;
			font-size: 0.9rem;
			color: black;
    		font-weight: 600;
    		font-family: 'Open Sans', sans-serif!important;
		}

		.remarcador {
			bottom: 0;
			left: 0;
		}

		.spinner-border {
			height: 18px;
			width: 18px;
		}
	}

</style>
